import { useEffect, useState } from 'react'
import SoldForecast from '../../components/Forecast/SoldForecast'
import { useApi } from '../../context/Api'
import ForecastModel, { MultiForecastModel } from '../../models/forecast.model'
import ScrollableContent from '../../components/ScrollableContent'

const MyForecasts = () => {
    const [forecasts, setForecasts] = useState<
        (ForecastModel | MultiForecastModel)[]
    >([])
    const { getMyForecasts } = useApi()
    
    const getData = async () => {
        const _forecasts = await getMyForecasts()
        setForecasts(_forecasts)
    }
    
    useEffect(() => {
        getData()
    }, [])
    
    return (
        <div className="h-full flex flex-col">
            {/* Banner Grafico Telegram */}
            <a 
                href="https://t.me/+-V5h7d0iMQxjZDE8" 
                target="_blank" 
                rel="noopener noreferrer"
                className="relative overflow-hidden bg-gradient-to-r from-blue-600 to-blue-500 rounded-xl p-4 md:p-6 mb-4 block hover:from-blue-700 hover:to-blue-600 transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl hover:shadow-blue-500/25 hover:scale-[1.02] transform"
            >
                {/* Pattern di sfondo decorativo */}
                <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full -translate-y-16 translate-x-16"></div>
                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/5 rounded-full translate-y-12 -translate-x-12"></div>
                
                {/* Contenuto del banner - Layout responsive */}
                <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-4">
                    <div className="flex items-center space-x-3 md:space-x-4">
                        {/* Icona Telegram */}
                        <div className="w-10 h-10 md:w-12 md:h-12 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm flex-shrink-0">
                            <span className="text-xl md:text-2xl">📱</span>
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="text-white font-bold text-base md:text-lg mb-1 leading-tight">
                                Canale Telegram GRATUITO
                            </h3>
                            <p className="text-blue-100 text-xs md:text-sm leading-relaxed">
                                Non perderti nemmeno un pronostico dei tuoi Tipster preferiti!
                            </p>
                        </div>
                    </div>
                    {/* Call to action - Centrato su mobile */}
                    <div className="flex items-center justify-center space-x-2 bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2 mx-auto md:mx-0 mt-2 md:mt-0">
                        <span className="text-white font-semibold text-sm whitespace-nowrap">ENTRA SUBITO</span>
                        <span className="text-white text-lg">→</span>
                    </div>
                    {/* Spacer invisibile solo su mobile per creare spazio dal bordo */}
                    <div className="h-3 md:h-0"></div>
                    <div className="h-3 md:h-0"></div>
                </div>
            </a>
            
            <ScrollableContent>
                <div className="flex flex-col gap-2">
                    {forecasts.map((f, i) => (
                        <SoldForecast key={i} forecast={f} />
                    ))}
                    {forecasts.length == 0 && (
                        <div className="text-center p-8 text-sm font-light text-gray-500/[.5]">
                            Nessun pronostico attivo.
                        </div>
                    )}
                </div>
            </ScrollableContent>
        </div>
    )
}

export default MyForecasts
